module.exports = __webpack_public_path__ + "c053da6aa9a1594856b7d062e84951f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/logo.png
// module id = 1108
// module chunks = 1